import { useContractIdentities } from '@/hooks/chain/useContractIdentities'

// Mounts the contract-identity probe once inside the web3 provider tree. Renders nothing:
// findings surface as sonner toasts plus console.table diagnostics from the hook itself.
export function ContractIdentityWatcher() {
    useContractIdentities()
    return null
}
